import {
  TwoFaVerifyForm,
  type TwoFaVerifyFormState,
} from '~/@mid_2fa/twofa-verify-form/TwoFaVerifyForm'
import { HeadingThree } from '~/@mid_ui/typography/HeadingThree'
import { useTwoFaCodeExpirationCountdown } from '~/@mid_2fa/twofa/useTwoFaCodeExpirationCountdown'
import { Text } from '~/@mid_ui/typography/Text'
import { Button } from '~/shadcn/ui/button/button'
import { CodeExpirationCountdown } from '~/@mid_2fa/twofa/CodeExpirationCountdown'

export type PhoneVerificationTwoFaCodeProps = {
  resendPhoneVerificationCode?: () => void
  resendCodeTime?: number
  handleVerifyPhoneNumberVerify: (props: TwoFaVerifyFormState) => void
  isRequestingVerifyPhoneNumberVerify: boolean
  verifiedPhoneNumber: string | null
  verifyPhoneNumberVerifyError: string | null
  twoFaCodeExpiresAt: Date | null
}

function PhoneVerificationTwoFaCode({
  resendPhoneVerificationCode,
  handleVerifyPhoneNumberVerify,
  isRequestingVerifyPhoneNumberVerify,
  verifiedPhoneNumber,
  verifyPhoneNumberVerifyError,
  twoFaCodeExpiresAt,
}: PhoneVerificationTwoFaCodeProps) {
  const { countdown, hasCodeExpired } =
    useTwoFaCodeExpirationCountdown(twoFaCodeExpiresAt)

  return (
    <>
      {hasCodeExpired && (
        <div className="flex flex-col items-center gap-4 mb-2 text-center">
          <HeadingThree>Zadanie SMS kódu</HeadingThree>
          <Text>SMS kód vypršal.</Text>
          <Button variant="outline" onClick={resendPhoneVerificationCode}>
            Znova odoslať SMS kód
          </Button>
        </div>
      )}
      {!hasCodeExpired && (
        <TwoFaVerifyForm
          formContent={
            <div className="flex flex-col items-center gap-2 text-center">
              <HeadingThree>Zadanie SMS kódu</HeadingThree>
              <Text>
                Overte svoj účet zadaním SMS kódu,
                <br />
                ktorý vám bol zaslaný na číslo {verifiedPhoneNumber}.
                <br />
                <CodeExpirationCountdown countdown={countdown} />
              </Text>
            </div>
          }
          fieldLabel="Overovaci SMS kód"
          submitButtonLabel="Potvrdiť kód"
          FooterComponent={(props) => (
            <div
              className="flex flex-col items-center justify-center mt-8 gap-2 w-full"
              {...props}
            />
          )}
          handleSubmitForm={handleVerifyPhoneNumberVerify}
          isRequesting={isRequestingVerifyPhoneNumberVerify}
          error={verifyPhoneNumberVerifyError}
        />
      )}
    </>
  )
}

export { PhoneVerificationTwoFaCode }
